import { render, staticRenderFns } from "./TimeUsageTab.vue?vue&type=template&id=0920b106&scoped=true"
import script from "./TimeUsageTab.vue?vue&type=script&lang=js"
export * from "./TimeUsageTab.vue?vue&type=script&lang=js"
import style0 from "./TimeUsageTab.vue?vue&type=style&index=0&id=0920b106&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0920b106",
  null
  
)

export default component.exports